import { render, staticRenderFns } from "./FreeButton.vue?vue&type=template&id=68ae9802&scoped=true&"
import script from "./FreeButton.vue?vue&type=script&lang=js&"
export * from "./FreeButton.vue?vue&type=script&lang=js&"
import style0 from "./FreeButton.vue?vue&type=style&index=0&id=68ae9802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae9802",
  null
  
)

export default component.exports